import Api from 'src/api/Base'

class GetCategories extends Api {
  requestUrl = `/api/category`
}

export default GetCategories
